export const PRODUCT_TYPE_VALIDATION = {
    name: {
        required: 'Nama produk type wajib diisi',
    },
}
